import { JustpayMediafileEndpointService } from "@/views/loyalty/shared/endpoint_services/justpay-mediafile-endpoint-service"

export class JustpayMediaFileService {
    constructor () {
        this.justpayMediafileEndpointService = new JustpayMediafileEndpointService()
    }

    async deletePictureFile (fileId) {
        return this.justpayMediafileEndpointService.deletePictureFile(fileId)
    }

    async getPictureFile (fileId) {
        return this.justpayMediafileEndpointService.getPictureFile(fileId)
    }

    async uploadPictureFile (file) {
        const data = new FormData()
        data.append("file", file)
        return this.justpayMediafileEndpointService.uploadPictureFile(data)
    }
}
